module.exports = __webpack_public_path__ + "img/craneFrontLeft.19cb9871.svg";